/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectReport } from './ProjectReport';
import {
    ProjectReportFromJSON,
    ProjectReportFromJSONTyped,
    ProjectReportToJSON,
    ProjectReportToJSONTyped,
} from './ProjectReport';
import type { ProjectLegacyReport } from './ProjectLegacyReport';
import {
    ProjectLegacyReportFromJSON,
    ProjectLegacyReportFromJSONTyped,
    ProjectLegacyReportToJSON,
    ProjectLegacyReportToJSONTyped,
} from './ProjectLegacyReport';
import type { ProjectData } from './ProjectData';
import {
    ProjectDataFromJSON,
    ProjectDataFromJSONTyped,
    ProjectDataToJSON,
    ProjectDataToJSONTyped,
} from './ProjectData';

/**
 * 
 * @export
 * @interface ProjectRole
 */
export interface ProjectRole {
    /**
     * 
     * @type {string}
     * @memberof ProjectRole
     */
    id?: string;
    /**
     * 
     * @type {ProjectData}
     * @memberof ProjectRole
     */
    project?: ProjectData;
    /**
     * 
     * @type {string}
     * @memberof ProjectRole
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsDailyOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsMainOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsDiscountsAndCoupons?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsMarketingChannelOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectOrderStatuses?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectIntegrations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectBilling?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectAffiliate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectMailing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectOfflineSpends?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProjectInvitations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProfitability?: boolean;
    /**
     * 
     * @type {Array<ProjectReport>}
     * @memberof ProjectRole
     */
    allowedReports?: Array<ProjectReport> | null;
    /**
     * 
     * @type {Array<ProjectLegacyReport>}
     * @memberof ProjectRole
     */
    allowedLegacyReports?: Array<ProjectLegacyReport> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsProfitMetrics?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRole
     */
    allowsPurchasePriceMetrics?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectRole
     */
    forbiddenChannels?: Array<string> | null;
}

/**
 * Check if a given object implements the ProjectRole interface.
 */
export function instanceOfProjectRole(value: object): value is ProjectRole {
    return true;
}

export function ProjectRoleFromJSON(json: any): ProjectRole {
    return ProjectRoleFromJSONTyped(json, false);
}

export function ProjectRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'project': json['project'] == null ? undefined : ProjectDataFromJSON(json['project']),
        'name': json['name'] == null ? undefined : json['name'],
        'allowsDailyOverview': json['allowsDailyOverview'] == null ? undefined : json['allowsDailyOverview'],
        'allowsMainOverview': json['allowsMainOverview'] == null ? undefined : json['allowsMainOverview'],
        'allowsDiscountsAndCoupons': json['allowsDiscountsAndCoupons'] == null ? undefined : json['allowsDiscountsAndCoupons'],
        'allowsMarketingChannelOverview': json['allowsMarketingChannelOverview'] == null ? undefined : json['allowsMarketingChannelOverview'],
        'allowsProjectProfile': json['allowsProjectProfile'] == null ? undefined : json['allowsProjectProfile'],
        'allowsProjectOrderStatuses': json['allowsProjectOrderStatuses'] == null ? undefined : json['allowsProjectOrderStatuses'],
        'allowsProjectIntegrations': json['allowsProjectIntegrations'] == null ? undefined : json['allowsProjectIntegrations'],
        'allowsProjectBilling': json['allowsProjectBilling'] == null ? undefined : json['allowsProjectBilling'],
        'allowsProjectAffiliate': json['allowsProjectAffiliate'] == null ? undefined : json['allowsProjectAffiliate'],
        'allowsProjectMailing': json['allowsProjectMailing'] == null ? undefined : json['allowsProjectMailing'],
        'allowsProjectOfflineSpends': json['allowsProjectOfflineSpends'] == null ? undefined : json['allowsProjectOfflineSpends'],
        'allowsProjectUsers': json['allowsProjectUsers'] == null ? undefined : json['allowsProjectUsers'],
        'allowsProjectInvitations': json['allowsProjectInvitations'] == null ? undefined : json['allowsProjectInvitations'],
        'allowsProfitability': json['allowsProfitability'] == null ? undefined : json['allowsProfitability'],
        'allowedReports': json['allowedReports'] === undefined ? undefined : json['allowedReports'] === null ? null : ((json['allowedReports'] as Array<any>).map(ProjectReportFromJSON)),
        'allowedLegacyReports': json['allowedLegacyReports'] === undefined ? undefined : json['allowedLegacyReports'] === null ? null : ((json['allowedLegacyReports'] as Array<any>).map(ProjectLegacyReportFromJSON)),
        'allowsProfitMetrics': json['allowsProfitMetrics'] == null ? undefined : json['allowsProfitMetrics'],
        'allowsPurchasePriceMetrics': json['allowsPurchasePriceMetrics'] == null ? undefined : json['allowsPurchasePriceMetrics'],
        'forbiddenChannels': json['forbiddenChannels'] === undefined ? undefined : json['forbiddenChannels'] === null ? null : json['forbiddenChannels'],
    };
}

export function ProjectRoleToJSON(json: any): ProjectRole {
    return ProjectRoleToJSONTyped(json, false);
}

export function ProjectRoleToJSONTyped(value?: ProjectRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'project': ProjectDataToJSON(value['project']),
        'name': value['name'],
        'allowsDailyOverview': value['allowsDailyOverview'],
        'allowsMainOverview': value['allowsMainOverview'],
        'allowsDiscountsAndCoupons': value['allowsDiscountsAndCoupons'],
        'allowsMarketingChannelOverview': value['allowsMarketingChannelOverview'],
        'allowsProjectProfile': value['allowsProjectProfile'],
        'allowsProjectOrderStatuses': value['allowsProjectOrderStatuses'],
        'allowsProjectIntegrations': value['allowsProjectIntegrations'],
        'allowsProjectBilling': value['allowsProjectBilling'],
        'allowsProjectAffiliate': value['allowsProjectAffiliate'],
        'allowsProjectMailing': value['allowsProjectMailing'],
        'allowsProjectOfflineSpends': value['allowsProjectOfflineSpends'],
        'allowsProjectUsers': value['allowsProjectUsers'],
        'allowsProjectInvitations': value['allowsProjectInvitations'],
        'allowsProfitability': value['allowsProfitability'],
        'allowedReports': value['allowedReports'] == null ? undefined : ((value['allowedReports'] as Array<any>).map(ProjectReportToJSON)),
        'allowedLegacyReports': value['allowedLegacyReports'] == null ? undefined : ((value['allowedLegacyReports'] as Array<any>).map(ProjectLegacyReportToJSON)),
        'allowsProfitMetrics': value['allowsProfitMetrics'],
        'allowsPurchasePriceMetrics': value['allowsPurchasePriceMetrics'],
        'forbiddenChannels': value['forbiddenChannels'],
    };
}

